import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-4 text-center">
      <p className="text-sm">
        Réalisé par <span className="font-semibold text-blue-400">Kaizer Phoenix</span>
      </p>
      <p className="text-xs mt-2">&copy; {new Date().getFullYear()} Tous droits réservés.</p>
    </footer>
  );
};

export default Footer;